export default __webpack_public_path__ + "f2203cc56f02647481ca72126e966f81.png";